import { useCompanyDetails } from "../cacheQueries";

/**
 * Returns whether the organization has any Remote ID Pro units (airplates)
 * registered. Used to gate UI affordances that are only relevant once a
 * unit is enrolled — e.g. the Operator ID block in Settings, and the
 * "Remote ID Pro" group in the side nav.
 *
 * Both consumers used to inline `companyDetails?.airplate.length > 0`;
 * centralising the check here keeps them aligned if the data shape evolves.
 */
export function useHasRemoteIdPros(): boolean {
  const { data: companyDetails } = useCompanyDetails();
  return !!(companyDetails?.airplate && companyDetails.airplate.length > 0);
}
